import configuration from '../utilities/configuration';

export const cardPaymentLimit = 9500;

export const encodedCustomerAuthorize = (): string => {
    //Basic Authentication Header -> the : indicates the end of the username + empty password
    const encoded = Buffer.from(configuration.paymentCustomerAuth + ":").toString("base64");
    return "Basic " + encoded;
}

export const LOGOS = {
    "Mastercard": "icons/mastercard.svg",
    "Visa": "icons/visa.svg"
};